import styles from "./forwardHeader.module.scss";
import React from "react";

export default function ForwardHeader() {
  return (
    <>
      <div className={styles.forwardHeader}>
        <span className={styles.forwordiconsec}></span>
        <span className={styles.forwardText}>Forwarded</span>
      </div>
    </>
  );
};

